export default __webpack_public_path__ + "static/media/h&h.ad348424.png";